import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <p className="editorial-label">loading the atelier…</p>
      </div>
    );
  }
  if (!user) {
    // Preserve the intended destination so the PWA start_url (and any deep
    // link) survives the login round-trip.
    const next = `${location.pathname}${location.search || ""}`;
    const target = next && next !== "/admin/login" ? `/admin/login?next=${encodeURIComponent(next)}` : "/admin/login";
    return <Navigate to={target} replace />;
  }
  return children;
}
